import * as React from 'react';
import '@swc/helpers';
import '@grandvisionhq/state';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import '../../../../types/product.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../operations/queries/get-frames-by-slug.js';
import '../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import '../../../../slots/context.js';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { useCLEcommContext } from '../context/CLEcommContext.js';

const useCLDeliveryIndicatorConfig = ()=>{
    const { state , selectors  } = useCLEcommContext();
    const lineItemDrafts = selectors.getLineItemDrafts(state, undefined);
    const [isConfiguratorValid] = selectors.isConfiguratorValid(state);
    const config = React.useMemo(()=>({
            // Check if there is at least one line item draft, meaning the user has configured at least one prescription.
            hasConfiguredLineItems: lineItemDrafts.length > 0,
            // Check that all required information has been filled in, i.e for both the left and right eye if enabled
            validLineItemDrafts: isConfiguratorValid ? lineItemDrafts : []
        })
    , [
        lineItemDrafts,
        isConfiguratorValid
    ]);
    return config;
};

export { useCLDeliveryIndicatorConfig };
//# sourceMappingURL=use-cl-delivery-indicator-config.js.map
